import React from 'react';
import { Eye, Heart } from 'lucide-react';

const fmt = (n) => {
  if (n === null || n === undefined) return null;
  if (n < 1000) return String(n);
  const k = (n / 1000).toFixed(1).replace('.', ',');
  return `${k.endsWith(',0') ? k.slice(0, -2) : k} k`;
};

export const StatBadge = ({ stats, className = '', size = 'sm' }) => {
  if (!stats) return null;
  const v = fmt(stats.views);
  const l = fmt(stats.likes);
  if (v === null && l === null) return null;
  const cls = size === 'lg' ? 'text-sm' : 'text-[11px]';
  return (
    <div className={`flex items-center gap-3 font-700 ${cls} ${className}`} data-testid="stat-badge">
      {v !== null && <span className="flex items-center gap-1" aria-label={`${stats.views} vues sur Citytoon.org`} title="Vues sur Citytoon.org"><Eye className="w-3.5 h-3.5" /> {v}</span>}
      {l !== null && <span className="flex items-center gap-1" aria-label={`${stats.likes} j’aime sur Citytoon.org`} title="J’aime sur Citytoon.org"><Heart className="w-3.5 h-3.5" /> {l}</span>}
    </div>
  );
};

export default StatBadge;
